import CourseLesson from 'src/model/CourseLesson';

const courseLessonDatabaseMap: Map<string, CourseLesson> = new Map<string, CourseLesson>([
  [
    'word_break',
    {
      courseLessonId: 'word_break',
      courseChapterId: 'dynamic_programming',
      title: 'Word Break',
      number: 1,
    },
  ],
  [
    'combination_sum',
    {
      courseLessonId: 'combination_sum',
      courseChapterId: 'dynamic_programming',
      title: 'Combination Sum',
      number: 2,
    },
  ],
  [
    'minimum_difference_between_subsets',
    {
      courseLessonId: 'minimum_difference_between_subsets',
      courseChapterId: 'dynamic_programming',
      title: 'Minimum Difference Between Subsets',
      number: 3,
    },
  ],
  [
    'decode_ways',
    {
      courseLessonId: 'decode_ways',
      courseChapterId: 'dynamic_programming',
      title: 'Decode Ways',
      number: 4,
    },
  ],
  [
    'longest_string_chain',
    {
      courseLessonId: 'longest_string_chain',
      courseChapterId: 'dynamic_programming',
      title: 'Longest String Chain',
      number: 5,
    },
  ],
  [
    'largest_rectangle_in_grid',
    {
      courseLessonId: 'largest_rectangle_in_grid',
      courseChapterId: 'dynamic_programming',
      title: 'Largest Rectangle In Grid',
      number: 6,
    },
  ],
  [
    'largest_rectangle_in_grid',
    {
      courseLessonId: 'largest_rectangle_in_grid',
      courseChapterId: 'dynamic_programming',
      title: 'Largest Rectangle In Grid',
      number: 6,
    },
  ],
  [
    'knight_probability_in_chessboard',
    {
      courseLessonId: 'knight_probability_in_chessboard',
      courseChapterId: 'dynamic_programming',
      title: 'Knight Probability In Chessboard',
      number: 7,
    },
  ],
  [
    'unique_paths_2',
    {
      courseLessonId: 'unique_paths_2',
      courseChapterId: 'dynamic_programming',
      title: 'Unique Paths 2',
      number: 8,
    },
  ],
  [
    'two_subarrays_with_target',
    {
      courseLessonId: 'two_subarrays_with_target',
      courseChapterId: 'dynamic_programming',
      title: 'Two Subarrays With Target',
      number: 9,
    },
  ],
  [
    'trapping_rainwater',
    {
      courseLessonId: 'trapping_rainwater',
      courseChapterId: 'algorithm',
      title: 'Trapping Rainwater',
      number: 1,
    },
  ],
  [
    'minimum_in_rotated_sorted_array',
    {
      courseLessonId: 'minimum_in_rotated_sorted_array',
      courseChapterId: 'algorithm',
      title: 'Minimum In Rotated Sorted Array',
      number: 2,
    },
  ],
  [
    'first_missing_positive',
    {
      courseLessonId: 'first_missing_positive',
      courseChapterId: 'algorithm',
      title: 'First Missing Positive',
      number: 3,
    },
  ],
  [
    'gas_station',
    {
      courseLessonId: 'gas_station',
      courseChapterId: 'algorithm',
      title: 'Gas Station',
      number: 4,
    },
  ],
  [
    'subarray_sum_equals_k',
    {
      courseLessonId: 'subarray_sum_equals_k',
      courseChapterId: 'algorithm',
      title: 'Subarray Sum Equals K',
      number: 5,
    },
  ],
  [
    'bulb_switcher_3',
    {
      courseLessonId: 'bulb_switcher_3',
      courseChapterId: 'algorithm',
      title: 'Bulb Switcher 3',
      number: 6,
    },
  ],
  [
    'car_fleet',
    {
      courseLessonId: 'car_fleet',
      courseChapterId: 'algorithm',
      title: 'Car Fleet',
      number: 7,
    },
  ],
  [
    'prison_cells_after_n_days',
    {
      courseLessonId: 'prison_cells_after_n_days',
      courseChapterId: 'algorithm',
      title: 'Prison Cells After N Days',
      number: 8,
    },
  ],
  [
    'number_of_matching_subsequences',
    {
      courseLessonId: 'number_of_matching_subsequences',
      courseChapterId: 'algorithm',
      title: 'Number of Matching Subsequences',
      number: 9,
    },
  ],
  [
    'product_of_array_except_self',
    {
      courseLessonId: 'product_of_array_except_self',
      courseChapterId: 'algorithm',
      title: 'Product Of Array Except Self',
      number: 10,
    },
  ],
  [
    'find_k_closest_elements',
    {
      courseLessonId: 'find_k_closest_elements',
      courseChapterId: 'algorithm',
      title: 'Find K Closest Elements',
      number: 11,
    },
  ],
  [
    'maximum_points_from_cards',
    {
      courseLessonId: 'maximum_points_from_cards',
      courseChapterId: 'algorithm',
      title: 'Maximum Points From Cards',
      number: 12,
    },
  ],
  [
    'maximum_length_of_subarray_with_positive_product',
    {
      courseLessonId: 'maximum_length_of_subarray_with_positive_product',
      courseChapterId: 'algorithm',
      title: 'Maximum Length Of Subarray With Positive Product',
      number: 13,
    },
  ],
  [
    'frequency_tracker',
    {
      courseLessonId: 'frequency_tracker',
      courseChapterId: 'algorithm',
      title: 'Frequency Tracker',
      number: 14,
    },
  ],
  [
    'first_completely_painted_row_or_column',
    {
      courseLessonId: 'first_completely_painted_row_or_column',
      courseChapterId: 'algorithm',
      title: 'First Completely Painted Row Or Column',
      number: 15,
    },
  ],
  [
    'longest_consecutive_sequence',
    {
      courseLessonId: 'longest_consecutive_sequence',
      courseChapterId: 'graph',
      title: 'Longest Consecutive Sequence',
      number: 1,
    },
  ],
  [
    'shortest_path_obstacle_elimination',
    {
      courseLessonId: 'shortest_path_obstacle_elimination',
      courseChapterId: 'graph',
      title: 'Shortest Path With Obstacle Elimination',
      number: 2,
    },
  ],
  [
    'largest_rectangle_in_histogram',
    {
      courseLessonId: 'largest_rectangle_in_histogram',
      courseChapterId: 'stack',
      title: 'Largest Rectangle In Histogram',
      number: 1,
    },
  ],
  [
    'asteroid_collision',
    {
      courseLessonId: 'asteroid_collision',
      courseChapterId: 'stack',
      title: 'Asteroid Collision',
      number: 2,
    },
  ],
  [
    'next_greater_element_1',
    {
      courseLessonId: 'next_greater_element_1',
      courseChapterId: 'stack',
      title: 'Next Greater Element 1',
      number: 3,
    },
  ],
  [
    'next_greater_element_2',
    {
      courseLessonId: 'next_greater_element_2',
      courseChapterId: 'stack',
      title: 'Next Greater Element 2',
      number: 4,
    },
  ],
]);

export default courseLessonDatabaseMap;
